var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8638 257.192L17.8638 103.834C17.8638 100.545 21.2733 98.363 24.2603 99.7411L164.936 164.645C166.533 165.381 167.556 166.979 167.556 168.738L167.556 322.434C167.556 325.727 164.139 327.909 161.151 326.523L20.4751 261.281C18.8827 260.543 17.8638 258.947 17.8638 257.192Z",
    fill: "#353F74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M331.558 257.192L331.558 103.834C331.558 100.545 328.148 98.363 325.161 99.7411L184.485 164.645C182.888 165.381 181.866 166.979 181.866 168.738L181.866 322.434C181.866 325.727 185.282 327.909 188.27 326.523L328.946 261.281C330.539 260.543 331.558 258.947 331.558 257.192Z",
    fill: "#353F74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6818 81.6253L173.174 19.8491C174.365 19.3099 175.732 19.3146 176.92 19.8623L310.907 81.6383C314.396 83.247 314.403 88.2035 310.918 89.8211L176.93 152.015C175.737 152.569 174.361 152.574 173.163 152.028L36.6714 89.8344C33.1481 88.229 33.1544 83.2217 36.6818 81.6253Z",
    fill: "#353F74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacro);
export default __webpack_public_path__ + "static/media/macro.2a0282cdf4c5c0a3f566effa94e26942.svg";
export { ForwardRef as ReactComponent };